export const trimEmail = (value) => value.length > 15 ? value.substring(0,12) + "..." : value;